export default "__VITE_ASSET__C65Fe$ec__"